export default __webpack_public_path__ + "8014d4555dd4661250c332d5c435daa9.png";